import { defaultTheme } from '@3plearning/react-components';
import palette from './palette';
import typography from './typography';
import colours from './colours';
import layout from './layout';
import * as overrides from './overrides';

export default {
  ...defaultTheme,
  palette,
  typography,
  colours,
  layout,
  overrides
};



// WEBPACK FOOTER //
// ./themes/upf-theme/index.js